import IndividualTable from '../../../IndividualTable';
import { sampleData } from "../../sampleData";

const Distance145 = () => {
  let winners = ["21", "69", "152", "483"];
  return <IndividualTable matchType={"8"} gender="M" event="145" subTitle="Kungdo" data={sampleData} topRankCount="4" winners={winners} />;
};
export default Distance145;
